import Service from '@ember/service';

export default class ElementHighlighterService extends Service {
  #previousHighlightedId: string | null = null;

  hasBeenHighlighted(id: string): boolean {
    return this.#previousHighlightedId === id;
  }

  markAsHighlighted(id: string): void {
    this.#previousHighlightedId = id;
  }

  reset(): void {
    this.#previousHighlightedId = null;
  }
}

declare module '@ember/service' {
  interface Registry {
    'element-highlighter': ElementHighlighterService;
  }
}
